import { css } from '@emotion/react';

import tooltipStyles from '../Tooltip/Tooltip.styles';

const button = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
    position: 'relative',
    borderRadius: 'var(--radius-component, 6px)',
    padding: '8px 12px',
    lineHeight: '20px',

    backgroundColor: 'var(--custom-action-color)',
    color: 'var(--custom-text-color)',

    '&:not(:disabled):hover': {
        backgroundColor: 'var(--custom-action-color-hover)',
    },
    '&:not(:disabled):active': {
        backgroundColor: 'var(--custom-action-color-active)',
    },

    '&:disabled': {
        backgroundColor: '#F5F7F9',
        color: '#647491',
        outline: '1px solid var(--border-color, #D3DBE5)',
        padding: '8px 11px',
        cursor: 'default',
    },
});

const addedToCartButton = css(button, {
    '& svg': {
        fill: '#34B857',
        width: 20,
        height: 20,
    },
});

const addingToCartButton = css(button, {
    '&:hover': {
        cursor: 'progress',
    },

    '& svg.loader-icon': {
        position: 'static',
    },
});

const viewCartPlaygroundTooltip = css(tooltipStyles.tooltip, {
    width: 217,
    whiteSpace: 'normal',
});

const errorMessageContainer = css({
    display: 'flex',
    alignItems: 'center',
    gap: 8,

    '& svg': {
        fill: '#E81332',
        width: 24,
        height: 24,
        flexShrink: 0,
    },
});

const errorMessage = css({
    color: '#E81332',
    fontSize: 12,
    lineHeight: '16px',
});

export default {
    button,
    addedToCartButton,
    addingToCartButton,
    viewCartPlaygroundTooltip,
    errorMessageContainer,
    errorMessage,
};
